import React, { useEffect } from "react";
import { View, StyleSheet } from "react-native";

import {
  createVisitRequestBody,
  getStoreUrl,
} from "@lib/utilities/HelperFunctions";
import { getCarrierName } from "@lib/utilities/Constants";

const Shareable = ({ navigation }: any) => {
  useEffect(() => {
    const handleRedirect = async () => {
      const storeUrl = await getStoreUrl();
      const reqBody = await createVisitRequestBody(
        "ref_link",
        "page_view",
        storeUrl,
      );
      try {
        await fetch(`${process.env.REACT_APP_BASE_API_URL}/smartLink`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "nexus-policy-source": getCarrierName(),
          },
          body: JSON.stringify(reqBody),
        });

        if (storeUrl) {
          window.location.href = storeUrl;
        }
      } catch (error) {
        console.error("Failed to open store:", error);
      } finally {
      }
    };

    handleRedirect();
  }, [navigation]);

  return <View style={styles.container}></View>;
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default Shareable;
